import Header from '../../widgets/Header';
import FaqAccordion from '../../widgets/FaqAccordion';

const FAQ = () => {
  return (
    <>
      <Header title="Frequently Asked Questions" rightContent={' '} />
      <main className="page-content strict-width x-space-top">
        <FaqAccordion />
      </main>
    </>
  );
};

export default FAQ;
